import React, { Component } from "react";
import { connect } from "react-redux";

import ConstData from "../../../lib/ConstData";
import { enTokenCMD } from "../../../lib/classTalk/CodeEnum";
import { ctWebActionType } from "../../../lib/ConstCommand";
import { downloadFileUtil, isNotEmptyStr } from "../../../lib/func/ExportFunction";

import { getIsForPblModeBrowser, isAndroidWebView, isIOSWebView } from "../../../lib/HandsUpClient";
import { getMySmallGroupSendKey } from "../../../lib/RabbitmqClient";

import {
    sendQuizAnswer
} from "../../../modules/quiz";

import {
    toggle_classTalk,
    appendSendMessage,
    appendSendAudioMemo,
    appendSendInkMemo,
    appendSendFileShare,
    appendSendFileShareProgress,
    emoticonSelectedToggle,
    emoticonSelectedCancel,
    addFunctionOpenedToggle,
    selectEmoticonSeq,
    selectFunctionSeq,
    inkMemoOpenedToggle,
    inkMemoClosedToggle,
    inkMemo_changeTool,
    voiceMemoClosedToggle,
    toggleFileShareMessage,
    openWhisperModal,
    respondWhisper,
    closeWhisperModal,
    webIsWhisperMode,
    setPassPossible
} from "../../../modules/classTalkLive";
import { openContentSendPanel } from "../../../modules/classTalk";

import {
    closeWatchLiveModal,
    changeLiveConnect,
    changeLiveConnectStatus,
    changeLiveSoundStatus,
    changeLiveStatusInfo
} from "../../../modules/live";

import CenteredModalInLive from "../../../components/template/modal/CenteredModalInLive";
import RightSideModalInLive from "../../../components/template/modal/RightSideModalInLive";

import PerformWatchingLiveInfo from "../../../components/live/PerformWatchingLiveInfo";
import ClassTalkLive from "../../../components/live/ClassTalkLive";
import InkMemoWindow from "../../../components/classtalk/inkMemo/InkMemoWindow";
import WatchingLiveMember from "../../../components/live/modal/WatchingLiveMember";
import WebWhisperModal from "../../../components/pblWhisper/WebWhisperModal";

class ClassTalkContainer extends Component {

    handleSelectedClassTalkFunc = ({ selectedFunc, emoticonSeq, func, msgText, data, dataUrl, filename, fileURL, idx, status, tool, source, mode, memberSeq }) => {
        const { userSeq, userNickname, profileImgUrl } = this.props;

        switch (selectedFunc) {
            case "SEND_QUIZ_ANSWER":
                // console.log("SEND_QUIZ_ANSWER - ", data);
                this.props.sendQuizAnswer({ userSeq, userNickname, data }); //profileImgUrl 포함
                break;

            case "SET_PASS_POSSIBLE":
                this.props.setPassPossible({ data });
                break;

            // --------------------------- Emoticon --------------------------- //
            case "EMOTICON_TOGGLE":
                this.props.emoticonSelectedToggle();
                break;

            case "EMOTICON_SELECT":
                this.props.selectEmoticonSeq(emoticonSeq);
                break;

            case "EMOTICON_CANCLE":
                this.props.emoticonSelectedCancel();
                break;

            // --------------------------- Send Message --------------------------- //
            case "SEND_MSG":
                this.props.appendSendMessage({ msgText, liveSeq: this.props.performLiveInfo.liveSeq, userSeq, userNickname, profileImgUrl });
                break;

            case "SEND_VOICE_MEMO":
                // this.props.appendSendAudioMemo({ mode: "web", command: enTokenCMD.chat_Voice, data, filename, teacherSeq: performLiveInfo.teacher_info.userSeq, liveSeq: this.props.performLiveInfo.liveSeq, userSeq, userNickname });
                this.props.appendSendAudioMemo({ selectedFunc, data, url: fileURL, liveSeq: this.props.performLiveInfo.liveSeq, userSeq, userNickname });
                break;

            // --------------------------- Classtalk func --------------------------- //
            case "FUNC_TOGGLE":
                this.props.addFunctionOpenedToggle();
                break;

            case "FUNC_SELECT":
                this.props.selectFunctionSeq(func);

                switch (func) {
                    case ctWebActionType.Whisper:
                        this.props.webIsWhisperMode({ web_isWhisper: !this.props.web_isWhisper });
                        break;

                    case ctWebActionType.InkMemo:
                        this.props.inkMemoOpenedToggle();
                        break;

                    case ctWebActionType.VoiceMemo:
                        break;

                    case ctWebActionType.FileShare:
                        let sendData = {
                            mode: "new-web",
                            command: enTokenCMD.ct_UploadAndShareFiles,
                            data,
                            filename,
                            teacherSeq: this.props.performLiveInfo.teacher_info.userSeq,
                            liveSeq: this.props.performLiveInfo.liveSeq,
                            userSeq,
                            userNickname,
                            isWhisper: this.props.isWhisperModalOpened || this.props.web_isWhisper,
                            smallGroupKey: getMySmallGroupSendKey(),
                            isMixedClassMember: this.props.isMixedClassMember ? "Y" : "N",
                            mixedClassStatus: this.props.performLiveInfo.mixedClassStatus === "Y" ? "Y" : "N",
                            onUploadProgress: progress => this.props.appendSendFileShareProgress({ data: progress })
                        };

                        if (this.props.isMixedClassMember) {
                            let localServerSeq = this.props.mixedClassInfo.localServerSeq;
                            let localLiveSeq = this.props.mixedClassInfo.localLiveSeq;
                            let localTeacherSeq = this.props.mixedClassInfo.localTeacherSeq;

                            sendData = {
                                ...sendData,
                                localServerSeq,
                                localLiveSeq,
                                localTeacherSeq
                            };
                        }

                        this.props.appendSendFileShare(sendData);
                        break;

                    default:
                        break;
                }
                break;

            case "CLOSE_VOICE_MEMO":
                this.props.voiceMemoClosedToggle();
                break;

            case "INK_MEMO":
                if (!this.props.isLiveChattingLocked) this.props.inkMemoOpenedToggle({ selectedFunc, fileURL, liveSeq: this.props.performLiveInfo.liveSeq, userSeq, userNickname });
                break;

            case "FILE_DOWNLOAD":
                console.log("FILE_DOWNLOAD -- ", fileURL, idx);
                /* if (isAndroidWebView()) {
                    window.fileDownload(fileURL, filename);
                } else {
                    this.handleFileDownload(fileURL, filename, idx);
                } */

                this.handleFileDownload(fileURL, filename, idx, data);
                break;

            case "FILE_OPEN":
                console.log("FILE_OPEN -- ", fileURL);
                if (fileURL !== undefined && fileURL !== null) {
                    window.open(fileURL);
                }
                break;

            case "PAGE_JPEG":
                break;

            case "INK_MEMO_TOOL":
                this.props.inkMemo_changeTool(tool);
                break;

            case "SEND_INK_MEMO":
                this.props.appendSendInkMemo({ data, url: dataUrl, liveSeq: this.props.performLiveInfo.liveSeq, userSeq, userNickname });
                break;

            case "CLOSE_INK_MEMO":
                this.props.inkMemoClosedToggle();
                break;

            case "OPEN_WHISPER":
                this.props.openWhisperModal({ data, idx });
                break;

            case "RESPOND_WHISPER":
                this.props.respondWhisper({ msgText, liveSeq: this.props.performLiveInfo.liveSeq, userSeq, userNickname, profileImgUrl });
                break;

            case "CLOSE_WHISPER_MODAL":
                this.props.closeWhisperModal();
                break;

            case "OPEN_CONTENT_SEND_PANEL":
                this.props.openContentSendPanel({
                    msgInfo: data,
                    idx,
                    source: source ? source : "whisper",
                    mode: mode ? mode : "content",
                    memberSeq: memberSeq ? memberSeq : (this.props.whisperMsgInfo ? this.props.whisperMsgInfo.memberSeq : undefined)
                });
                break;

            case "LIVE_CON":
                this.props.changeLiveConnect({ isConnect: status });
                break;

            case "LIVE_CON_STATUS":
                this.props.changeLiveConnectStatus({ status });
                break;

            case "LIVE_SOUND_STATUS":
                this.props.changeLiveSoundStatus({ status });
                break;

            case "LIVE_RECON":
                this.props.changeLiveStatusInfo({ kind: "video" });
                break;

            case "NONE":
                this.props.closeWatchLiveModal();
                break;

            default:
                this.props.handleSelectedLiveFunc({ selectedFunc });
                break;
        }
    }

    /**
     * 파일 다운로드 핸들러 (UI 버튼 클릭 시 호출)
     * 실제 다운로드 로직은 downloadFileUtil에 위임하고,
     * 이 컴포넌트에서만 필요한 Redux dispatch(toggleFileShareMessage)를 콜백으로 전달
     *
     * @param {string} url - 다운로드 URL
     * @param {string|null} originalFileName - 원본 파일명
     * @param {number} idx - 메시지 목록에서의 인덱스 (Redux 상태 업데이트용)
     */
    handleFileDownload = async (url, originalFileName, idx, fileMsgInfo = {}) => {
        const {
            contentInfo = null,
            executeYn = "N",
            fileTransferType = "file-transfer",
            isAutoDownloadAllowed = false,
            isOverwriteAllowed = false,
            contentKind = "intensiveControl",
            forceWhisper = undefined,
        } = fileMsgInfo || {};

        if (getIsForPblModeBrowser() && window.eoapi !== undefined && window.eoapi !== null) {
            window.eoapi.extInvoke("downloadFile", [JSON.stringify({
                url,
                originalFileName,
                contentInfo,
                ...(contentInfo || {}),
                executeYn,
                fileTransferType,
                isAutoDownloadAllowed,
                isOverwriteAllowed,
                kind: contentKind,
                forceWhisper,
                idx,
            })]);

            this.props.toggleFileShareMessage({ idx, isClickedBtn: true });
            return;
        }

        await downloadFileUtil(
            url,
            originalFileName,
            isOverwriteAllowed,
            executeYn,
            contentInfo,
            idx,
            // 다운로드가 시작되면 해당 메시지의 isClickedDownload를 true로 변경
            (downloadedIdx) => {
                this.props.toggleFileShareMessage({
                    idx: downloadedIdx,
                    isClickedBtn: true
                });
            },
            contentKind,
        );
    }

    render() {
        const { userSeq } = this.props;
        const { performLiveInfo, performLiveStatusInfo, performHandsUpStatusInfo } = this.props;
        const { classTalkVisibility } = this.props;
        const { handleSelectedClassTalkFunc } = this;

        return (
            <div id="classtalk" className={(performLiveStatusInfo.isConnect ? " connect" : "")} style={{ visibility: `${classTalkVisibility}` }}>
                {
                    this.props.isLiveMemberModalOpened &&
                    <RightSideModalInLive
                        modalClose={handleSelectedClassTalkFunc}
                        style={{ margin: '5px', visibility: 'inherit' }}
                    >
                        <WatchingLiveMember
                            style={{ visibility: 'inherit' }}
                            userSeq={userSeq}
                            performLiveInfo={performLiveInfo}
                            handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                        />
                    </RightSideModalInLive>
                } {
                    this.props.isWhisperModalOpened &&
                    <CenteredModalInLive
                        modalClose={handleSelectedClassTalkFunc}
                        style={{ margin: '5px', visibility: `${classTalkVisibility}` }}
                    >
                        <WebWhisperModal
                            openInfo={this.props.openInfo}
                            msgInfo={this.props.whisperMsgInfo}
                            whisperMemberSeq={this.props.whisperMsgInfo ? this.props.whisperMsgInfo.memberSeq : undefined}
                            isLiveChattingLocked={this.props.isLiveChattingLocked}
                            // 20260908 수정: 웹 귓속말 파일 업로드 진행률을 열린 귓속말 모달에도 표시한다.
                            isProgressBarShow={this.props.isProgressBarShow}
                            progressCount={this.props.progressCount}
                            handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                        />
                    </CenteredModalInLive>
                } {
                    !this.props.isLiveChattingLocked && this.props.isInkMemoOpened &&
                    <CenteredModalInLive
                        modalClose={handleSelectedClassTalkFunc}
                        style={{ margin: '5px', visibility: `${classTalkVisibility}` }}
                    >
                        <InkMemoWindow
                            style={{ visibility: `${classTalkVisibility}` }}
                            toolMode={this.props.toolMode}
                            inkMemoFile={this.props.inkMemoFile}
                            handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                        />
                    </CenteredModalInLive>
                }
                <PerformWatchingLiveInfo
                    isGuestYn={this.props.isGuestYn}
                    broadcastOpenYN={this.props.broadcastOpenYN}
                    performLiveInfo={performLiveInfo}
                    handleSelectedLiveFunc={this.props.handleSelectedLiveFunc}
                />
                <ClassTalkLive
                    classTalkVisibility={classTalkVisibility}
                    web_isWhisper={this.props.web_isWhisper}
                    openInfo={this.props.isWhisperModalOpened ? this.props.tmpOpenInfo : this.props.openInfo}
                    isLiveChattingLocked={this.props.isLiveChattingLocked}
                    classTalkMsg={this.props.classTalkMsg}
                    isProgressBarShow={this.props.isProgressBarShow}
                    progressCount={this.props.progressCount}
                    handsUpYN={performLiveInfo.handsUpYN}
                    myHandsUpYN={performHandsUpStatusInfo.myHandsUpYN}
                    connectStatus={performLiveStatusInfo.connectStatus}
                    isConnectedOnScreenApp={this.props.isConnectedOnScreenApp}
                    handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                />
            </div>
        );
    }
}

export default connect(
    ({ classTalkLive, user, live, hiclasstv }) => ({
        // userNickname                : user.userNickname,
        profileImgUrl               : user.profileImgUrl,
        isMixedClassMember          : live.isMixedClassMember,

        mixedClassInfo              : live.mixedClassInfo,

        isInkMemoOpened             : classTalkLive.isInkMemoOpened,
        inkMemoFile                 : classTalkLive.inkMemoFile,        
        toolMode                    : classTalkLive.toolMode,

        classTalkMsg                : classTalkLive.receivedMsg,
        isProgressBarShow           : classTalkLive.isProgressBarShow,
        progressCount               : classTalkLive.progressCount,

        web_isWhisper               : classTalkLive.web_isWhisper,
        whisperMsgInfo              : classTalkLive.whisperMsgInfo,

        isLiveMemberModalOpened     : live.isLiveMemberModalOpened,

        isLiveChattingLocked        : live.isLiveChattingLocked,

        tmpOpenInfo     : {
            isEmoticonSelected      : false,
            selectEmoticonSeq       : -1,
            isAddFunctionOpened     : false,
            isAudioOpened           : false,
            audioStatus             : "STOPED"
        },
        openInfo        : {
            isEmoticonSelected      : classTalkLive.isEmoticonSelected,
            selectedEmoticonSeq     : classTalkLive.selectedEmoticonSeq,
            isAddFunctionOpened     : classTalkLive.isAddFunctionOpened,
            isAudioOpened           : classTalkLive.isAudioOpened,
            audioStatus             : classTalkLive.audioStatus,
        },

        isConnectedOnScreenApp      : hiclasstv.isConnectedOnScreenApp,
    }),
    {
        toggle_classTalk,
        inkMemoOpenedToggle,
        inkMemoClosedToggle,
        inkMemo_changeTool,
        closeWatchLiveModal,
        emoticonSelectedToggle,
        emoticonSelectedCancel,
        addFunctionOpenedToggle,

        selectEmoticonSeq,
        selectFunctionSeq,

        appendSendMessage,
        appendSendAudioMemo,
        appendSendInkMemo,
        appendSendFileShare,
        appendSendFileShareProgress,

        openWhisperModal,
        respondWhisper,
        closeWhisperModal,
        webIsWhisperMode,
        openContentSendPanel,

        voiceMemoClosedToggle,
        toggleFileShareMessage,
        setPassPossible,

        changeLiveConnect,
        changeLiveConnectStatus,
        changeLiveSoundStatus,
        changeLiveStatusInfo,

        sendQuizAnswer
    }
)(ClassTalkContainer);
